const getBreadcrumbSchema = breadcrumbs => {
  if (!breadcrumbs) {
    return null;
  }

  const breadcrumbList = [];
  if (breadcrumbs.length > 0) {
    breadcrumbs.forEach((breadcrumb, index) => {
      breadcrumbList[index] = {
        '@type': 'ListItem',
        position: index,
        item: {
          '@id': breadcrumb.link,
          name: breadcrumb.text,
        },
      };
    });
  }
  return {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbList,
  };
};

export default getBreadcrumbSchema;
